import React from 'react';
import paypalIcon from '/fallbacks/paypal-new.svg';

const paypalBtnStyles = window?.post_template?.checkout_v3_global_components;

const PaypalButton = ({ type, text, handleClick, margin, formNoValidate = true }) => {
	const paypalStyles = {
		'--paypalBackground': paypalBtnStyles.checkout_v3_components_paypalBackground,
		'--paypalHover': paypalBtnStyles.checkout_v3_components_paypalBackgroundHover,
		'--paypalShadow': paypalBtnStyles.checkout_v3_components_paypalShadowColor,
		'--paypalShadowHover': paypalBtnStyles.checkout_v3_components_paypalShadowColorHover,
		'--paypalTextColor': paypalBtnStyles.checkout_v3_components_paypalTextColor,
		marginTop: margin,
	};
	return (
		<button
			onClick={handleClick}
			style={paypalStyles}
			formNoValidate={formNoValidate}
			type={type}
			className="submitPaypal submitPaypal--active"
		>
			<span>{text}</span>
			<img src={paypalIcon} alt="PayPal" style={{ height: '32px', width: '120px' }} />
		</button>
	);
};

export default PaypalButton;
